import { Physics } from "phaser";

export class Actor extends Physics.Arcade.Sprite {
  public health = 100;
  public alcohol = 100;
  public direction: string = "right";

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    frame?: string | number,
  ) {
    super(scene, x, y, texture, frame);
    this.setScale(2);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.getBody().setCollideWorldBounds(true);
  }

  public animateDamage(value?: number): void {
    this.scene.tweens.add({
      targets: this,
      duration: 100,
      repeat: 3,
      yoyo: true,
      alpha: 0.5,
      onStart: () => {
        if (value) {
          this.health = this.health - value;
        }
      },
      onComplete: () => {
        this.setAlpha(1);
      },
    });
  }

  protected getBody(): Physics.Arcade.Body {
    return this.body as Physics.Arcade.Body;
  }

  /**
   * Updates the actor's direction based on its velocity.
   * Used for click mode movement.
   */
  public updateDirectionFromVelocity(): void {
    if (this.body) {
      // Only update direction if the player is actually moving
      if (this.body.velocity.x !== 0 || this.body.velocity.y !== 0) {
        // Determine the dominant direction (horizontal or vertical)
        if (Math.abs(this.body.velocity.x) > Math.abs(this.body.velocity.y)) {
          // Horizontal movement is dominant
          this.direction = this.body.velocity.x > 0 ? "right" : "left";
        } else {
          // Vertical movement is dominant
          this.direction = this.body.velocity.y > 0 ? "down" : "up";
        }
      }
    }
  }
}
